// Offerte: stessa pagina del Catalogo (grafica, filtri, scheda prodotto, carrello),
// con i soli prodotti in offerta e il prezzo d'offerta.
import React from 'react';
import Catalogo from './Catalogo';

const OnSale = (props) => <Catalogo {...props} variant="sale" />;

export default OnSale;
